if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

//tablet menu
if(document.getElementById('tabletBurger')){
    document.getElementById('tabletBurger').addEventListener('click', function(){
        if(!document.getElementById('primary-nav').classList.contains('open')){
            document.getElementById('primary-nav').classList.add('open');
            this.classList.add('open')
        } else {
            document.getElementById('primary-nav').classList.remove('open');
            this.classList.remove('open')
        }
    });
}

// Desplegable menu MOBILE
// Open
$(" #mobile-menu-button ").on("click", function(e){
    e.preventDefault();
    $(this).addClass('opened');
    $('.mobile-navigation').addClass('opened');
});
// Close
$(" #close-menu ").on("click", function(e){
    e.preventDefault();
    $('#mobile-menu-button').removeClass('opened');
    $('.mobile-navigation').removeClass('opened');
});

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    let isMobile = window.navigator.userAgent.toLocaleLowerCase()
    isMobile = isMobile.indexOf( "mobile" ) != "-1" ? true : false

    if( isMobile ){
        let primary_nav_7 = [...document.querySelectorAll( ".primary-nav-7 a" )][1]
        if( primary_nav_7 )
            primary_nav_7.setAttribute( "href", "https://www.chronogolf.com/club/king-and-prince-golf-course" )
    }


    $('.sym-slides').slick({
        accessibility: false
    });

})();